<p-dialog
    [visible]="visible()"
    (visibleChange)="visible.set($event)"
    [style]="{ 'max-width': '500px', width: '100%' }"
    [modal]="true"
    [closable]="false"
    header="Login"
    appendTo="body">
    <p>
        It looks like this is the first time you are using NHS login to link your ORB account. Please enter the password you use for your
        ORB login so we can link your accounts and log you in correctly.
    </p>

    <form class="inputs-group" [formGroup]="loginForm" (ngSubmit)="login()">
        <p class="text-center font-bold">{{ email() }}</p>

        @if (errorMessage()) {
            <p-message styleClass="mb-5 w-full justify-content-start" severity="error" [text]="errorMessage()"> </p-message>
        }

        @switch (currentStep()) {
            @case ("password") {
                <div class="inputs-group-row">
                    <span class="p-float-label inputs-group-row-value">
                        <input
                            pPassword
                            showPassword
                            placeholder="Enter your password"
                            formControlName="password"
                            [feedback]="false"
                            class="show-placeholder" />
                    </span>
                </div>
            }

            @case ("2fa") {
                <p class="two-factor-message">Please use your mobile app to get the two-factor code and enter it below</p>

                <div class="inputs-group-row">
                    <span class="p-float-label inputs-group-row-value">
                        <input
                            pInputText
                            formControlName="twoFactorCode"
                            autocomplete="off"
                            placeholder="Authenticator code"
                            class="show-placeholder" />
                    </span>
                </div>
            }

            @case ("linking") {
                <div class="mb-3">
                    <p class="text-center">Completing registration</p>
                    <m-loading></m-loading>
                </div>
            }
        }

        <div class="flex align-items-center justify-content-end">
            <button
                pButton
                type="submit"
                label="Log in"
                class="m-button-primary"
                [loading]="requestOngoing()"
                [disabled]="loginForm.invalid || linkError()">
                <i class="material-icons">person</i>
            </button>

            <button
                pButton
                type="button"
                icon="pi pi-times"
                class="mr-2 p-button-secondary"
                label="Cancel"
                (click)="visible.set(false)"></button>
        </div>
    </form>

    @if (recaptchaMessageVisible()) {
        <p class="recaptcha-terms-message text-0 mt-5 text-center">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </p>
    }
</p-dialog>
